const selectSettings = state => (state.settings && state.settings.data) || [];

export default selectSettings;
